<template>
  <div class="formdata building">
    <div class="header-container">
    <h3 id="building_question">Um welche Art von Haus handelt es sich?</h3>
</div>
    <CustomRadioGroup
        :options="buildingTypes"
        v-model="selectedBuildingType"
        aria-labelledby="building_question"
        :unique="buildingTypeQuestion"
        @optionSelected="submit"
    >
      <template #option="{ option }">
        <label :for="'building_type_' + option.value">
          <img :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomRadioGroup>



    <button class="button button_yellow right" v-if="selectedBuildingType" @click="submit">Weiter</button>
  </div>
</template>

<script setup>
import {computed} from 'vue';
import {useWorkflowStore} from '../../stores/workflow.js';
import {buildingTypes, buildingTypesApi} from '@/data/buildingTypes.js';
import CustomRadioGroup from "@/components/CustomRadioGroup.vue";

const workflowStore = useWorkflowStore();


const getBuildingTypeEventData = (selectedValue) => {
  const fullBuildingType = buildingTypes.find(bt => bt.value === selectedValue);

  if (fullBuildingType) {
    return {
      value: selectedValue,
      apiDefinition: buildingTypesApi,
      apiValue: fullBuildingType.api,
      available: fullBuildingType.available
    };
  }
  console.warn(`[getBuildingTypeEventData] Building type with value '${selectedValue}' not found.`);
  return null;
};


const selectedBuildingType = computed({
  get() {
    return workflowStore.workflowContext.formData.building?.type || null;
  },
  set(newValue) {
    // Der Setter wird aufgerufen, sobald der Benutzer einen Radio-Button auswählt.
    // Hier senden wir ein Event, das den Wert sofort im Store aktualisiert.
    const eventData = getBuildingTypeEventData(newValue);
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_BUILDING_TYPE',
      data: eventData,
    });
  }
});



const submit = () => {
  // Diese Funktion wird nur aufgerufen, wenn der "Weiter"-Button geklickt wird.
  // Der Wert ist bereits durch den Setter des computed properties im Store gespeichert.
  if (selectedBuildingType.value) {
    const eventData = getBuildingTypeEventData(selectedBuildingType.value);
    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: eventData,
    });
  }
};


</script>

<style scoped>




</style>